import Vue from "vue";
import Vuex from "vuex";
import { websiteModule } from "./website/stores/WebsiteStore";
import { doctorModule } from "./doctor-app/stores/DocrorStore";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    websiteModule,
    doctorModule
  },
  state: {},
  mutations: {},
  actions: {}
});
